import React from "react";
import { Box, Skeleton } from "@mui/material";
import PageContainer from "../PageContainer";
import TemplatesSectionSkeleton from "./TemplatesSectionSkeleton";

/**
 * The Create page while its code downloads: hero, the notice type cards, then
 * the same Templates placeholder the page shows while Templates load.
 */
const CreateNoticeSkeleton: React.FC = () => (
  <PageContainer>
    <Box role="status" aria-label="Loading Create">
      <Skeleton
        variant="rounded"
        sx={{
          height: { xs: 200, md: 240 },
          mb: 4,
          mt: { xs: 2, md: 0 },
          maxWidth: 1400,
          borderRadius: { xs: 2, md: 3 },
        }}
      />
      <Skeleton variant="text" width={260} sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }} />
      <Skeleton variant="text" sx={{ fontSize: "1rem", mt: 1.5, mb: 4, maxWidth: 560 }} />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, minmax(0, 1fr))",
            md: "repeat(4, minmax(0, 1fr))",
          },
          gap: { xs: 2, sm: 2.5 },
        }}
      >
        {Array.from({ length: 8 }).map((_, card) => (
          <Skeleton key={card} variant="rounded" sx={{ height: { xs: 220, md: 264 } }} />
        ))}
      </Box>
      <TemplatesSectionSkeleton />
    </Box>
  </PageContainer>
);

export default CreateNoticeSkeleton;
